<template>
  <div>
    <div class="container-msg">
      <div class="mainContent-msg">
        <!-- <div class="head-msg">
          <div class="head-content">
            <img src="./邮箱绑定教程_files/logo1.png">
            <h1>邮箱绑定教程</h1>
          </div>
        </div>
        <p class="msg-time">20170718</p> -->
        <div class="main-body" id="article-content">
          <h1 id="-2">一、绑定邮箱的意义？</h1>

          <blockquote>
            <p>此操作是将邮箱账号托管在系统中，由系统智能同步邮箱中简历，减轻HR工作负担，提高效率。</p>

            <p>
              绑定过程只需填写对应的邮箱账号信息，最后确认无误后保存即可。其中，需要明确您使用的是哪种邮箱类型，比如163邮箱、QQ邮箱、腾讯企业邮箱等，或者是贵公司自己搭建的邮件服务。根据对应的邮箱服务器类型，确定收件服务器地址、端口号两个重要信息。
            </p>

            <p>在绑定前，需要通过浏览器登陆邮箱，<strong>在“设置”中确认当前邮箱开启了“ IMAP/SMTP服务”服务。如有疑问请联系易招聘客服</strong>。</p>
          </blockquote>

          <h1 id="-3">二、如何绑定邮箱获取简历？</h1>

          <blockquote>
            <h2 id="1">第1步：填写邮箱</h2>
          </blockquote>

          <!-- <p><img src="./邮箱绑定教程_files/1577413422159.png" alt=""></p> -->

          <p>填写邮箱地址，此邮箱为收取招聘渠道简历的邮箱。请注意填写完整的邮件地址，如：support@sogukj.com、123456@qq.com。</p>

          <blockquote>
            <h2 id="2">第2步：填写密码</h2>
          </blockquote>

          <!-- <p><img src="./邮箱绑定教程_files/1577413446644.png" alt=""></p> -->

          <p>邮箱密码为邮箱授权码，少部分无授权码邮箱可直接输入密码。</p>

          <p>（1）登录密码：登陆密码即为您平时登陆邮箱的密码</p>

          <p>（2）授权码：由于许多邮件服务商出于安全性考虑，不支持用户直接使用登陆密码用于第三方使用，所以会以授权码代替密码。授权码需要用户自行设置开启并获取。</p>

          <h3 id="1httpsworkweixinqqcomhelpperson_id0doc_id301fromsearchhelptypeexmail">示例1.腾讯企业邮开启授权码使用（附：<a
              href="https://work.weixin.qq.com/help?person_id=0&amp;doc_id=301&amp;from=search&amp;helpType=exmail">微信企业邮箱如何开启安全登录获取客户端专用密码？</a>）
          </h3>

          <p>如果腾讯企业邮开启了微信安全登录，需要使用授权码。只有此种情况需要如此</p>

          <!-- <p><img src="./邮箱绑定教程_files/1577413446644.png" alt=""></p> -->

          <!-- <p><img src="./邮箱绑定教程_files/1577415450356.png" alt=""></p> -->

          <h3
            id="2163126yeahhttphelpmail163comfaqdetaildocoded7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac2cda80145a1742516">
            示例2：网易个人邮箱开启授权码并使用（附：<a
              href="http://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac2cda80145a1742516">163/126/yeah免费邮箱授权码设置方法</a>）
          </h3>

          <!-- <p><img src="./邮箱绑定教程_files/1577415590152.png" alt="" width="1280" height="600"></p> -->

          <!-- <p><img src="./邮箱绑定教程_files/1577415677814.png" alt=""></p> -->

          <!-- <p><img src="./邮箱绑定教程_files/1577413570148.png" alt=""></p> -->

          <!-- <p><img src="./邮箱绑定教程_files/1577413589533.png" alt=""></p> -->

          <p>其他邮件服务商的开启授权码的方式，请您百度搜索。</p>

          <blockquote>
            <h2 id="3">第3步：选择邮箱服务器类型</h2>
          </blockquote>

          <!-- <p><img src="./邮箱绑定教程_files/1577413946158.png" alt=""></p> -->

          <p>邮箱服务器类型共三种。在选择您的服务类型之前，请先确保您已开通相关服务</p>

          <h3 id="1-1">示例1：腾讯企业邮</h3>

          <!-- <p><img src="./邮箱绑定教程_files/1577414064099.png" alt=""></p> -->

          <h3 id="2-1">示例2：网易个人邮箱</h3>

          <!-- <p><img src="./邮箱绑定教程_files/1577414086658.png" alt="" width="1280" height="600"></p> -->

          <blockquote>
            <h2 id="4">第4步：填写服务器地址以及端口号</h2>
          </blockquote>

          <!-- <p><img src="./邮箱绑定教程_files/1577414112412.png" alt=""></p> -->

          <p>（1）如果贵公司没有自建邮件服务器（即默认状态，使用第三方邮件服务商提供的服务器），请参考此表：</p>

          <table border="1" style="border-collapse:collapse;margin:auto">
            <tbody>
              <tr>
                <th>邮箱类型</th>
                <th>IMAP服务器地址</th>
                <th>端口号</th>
                <th>POP3服务器地址</th>
                <th>端口号</th>
                <th>参考链接</th>
              </tr>

              <tr>
                <td>QQ邮箱</td>
                <td>imap.qq.com</td>
                <td>993</td>
                <td>pop.qq.com</td>
                <td>995</td>
                <th><a href="https://service.mail.qq.com/cgi-bin/help?subtype=1&amp;&amp;id=28&amp;&amp;no=167">
                    IMAP、POP3</a></th>
              </tr>

              <tr>
                <td>腾讯企业邮箱</td>
                <td>imap.exmail.qq.com</td>
                <td>993</td>
                <td>pop.exmail.qq.com</td>
                <td>995</td>
                <th><a href="https://open.work.weixin.qq.com/help?person_id=0&amp;doc_id=431&amp;helpType=exmail">
                    腾讯企业邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>腾讯企业邮箱(海外)</td>
                <td>hwimap.exmail.qq.com</td>
                <td>993</td>
                <td>hwpop.exmail.qq.com</td>
                <td>995</td>
                <th><a href="https://open.work.weixin.qq.com/help?person_id=0&amp;doc_id=431&amp;helpType=exmail">
                    腾讯企业邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>阿里云邮箱个人版</td>
                <td>imap.aliyun.com</td>
                <td>993</td>
                <td>pop3.aliyun.com</td>
                <td>995</td>
                <th><a href="https://mailhelp.aliyun.com/freemail/detail.vm?knoId=5869705"> 阿里云邮箱个人版服务器地址</a></th>
              </tr>

              <tr>
                <td>阿里云邮箱企业版</td>
                <td>imap.qiye.aliyun.com</td>
                <td>993</td>
                <td>pop.qiye.aliyun.com</td>
                <td>995</td>
                <th><a href="http://mailhelp.mxhichina.com/smartmail/detail.vm?knoId=5871700"> 阿里云邮箱企业版服务器地址</a></th>
              </tr>

              <tr>
                <td>网易163个人邮箱</td>
                <td>pop.163.com</td>
                <td>995</td>
                <td>pop.163.com</td>
                <td>995</td>
                <th><a
                    href="https://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac22dc0e9af8168582a">
                    网易163个人邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>网易163付费企业邮箱</td>
                <td>建议您使用在线查询</td>
                <td>993</td>
                <td>建议您使用在线查询</td>
                <td>995</td>
                <th><a href="https://qiye.163.com/help/client-profile.html"> 在线查询网易企业版服务器地址</a></th>
              </tr>

              <tr>
                <td>网易163免费企业邮箱</td>
                <td>建议您使用在线查询</td>
                <td>993</td>
                <td>建议您使用在线查询</td>
                <td>995</td>
                <th><a href="https://qiye.163.com/help/client-profile.html"> 在线查询网易企业版服务器地址</a></th>
              </tr>

              <tr>
                <td>网易126邮箱</td>
                <td>imap.126.com </td>
                <td>993</td>
                <td>pop.126.com</td>
                <td>995</td>
                <th><a href="http://help.163.com/09/1221/09/5R20H8L100753VB9.html?servCode=6020374"> 126邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>网页yeah邮箱</td>
                <td>imap.yeah.net</td>
                <td>993</td>
                <td>pop.yeah.net</td>
                <td>995</td>
                <th><a href="http://help.163.com/09/1130/15/5PCL1RDO00753VBA.html"> yeah邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>网易netease邮箱</td>
                <td>imap.netease.com</td>
                <td>993</td>
                <td>pop.netease.com</td>
                <td>995</td>
                <th><a href="http://mail.163.com/mailhelp/client.htm"> netease邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>新浪com邮箱</td>
                <td>imap.sina.com</td>
                <td>993</td>
                <td>pop.sina.com、pop3.sina.com</td>
                <td>995</td>
                <th><a href="http://help.sina.com.cn/comquestiondetail/view/160/"> 新浪邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>新浪cn邮箱</td>
                <td>imap.sina.cn</td>
                <td>993</td>
                <td>pop.sina.cn、pop3.sina.cn</td>
                <td>995</td>
                <th><a href="http://help.sina.com.cn/comquestiondetail/view/160/"> 新浪邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>新浪vip邮箱</td>
                <td>imap.vip.sina.com</td>
                <td>993</td>
                <td>pop3.vip.sina.com</td>
                <td>995</td>
                <th><a href="http://help.sina.com.cn/i/164/703_3.html">IMAP、 POP3</a></th>
              </tr>

              <tr>
                <td>搜狐闪电邮</td>
                <td>imap.sohu.com</td>
                <td>993</td>
                <td>pop3.sohu.com</td>
                <td>995</td>
                <th><a href="https://mail.sohu.com/fe/#/help"> 点击链接后点击outlook设置和IMAP配置</a></th>
              </tr>

              <tr>
                <td>搜狐VIP邮箱</td>
                <td>imap.sohu.com</td>
                <td>993</td>
                <td>pop3.vip.sohu.com</td>
                <td>995</td>
                <th><a href="https://vip.sohu.com/#/help"> 点击链接后搜索IMAP或POP3</a></th>
              </tr>

              <tr>
              </tr>
              <tr>
                <td>雅虎邮箱Yahoo</td>
                <td>imap.mail.yahoo.com</td>
                <td>993</td>
                <td>pop.mail.yahoo.com.cn</td>
                <td>995</td>
                <th><a href="https://baike.1688.com/doc/view-d2331360.html"> 雅虎POP邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>Office 365</td>
                <td>partner.outlook.cn</td>
                <td>993</td>
                <td>outlook.office365.com</td>
                <td>995</td>
                <th><a
                    href="https://support.office.com/zh-cn/article/Outlook-com-%E7%9A%84-POP%E3%80%81IMAP-%E5%92%8C-SMTP-%E8%AE%BE%E7%BD%AE-d088b986-291d-42b8-9564-9c414e2aa040">
                    点击链接后选择POP、IMAP、SMTP设置</a></th>
              </tr>

              <tr>
                <td>139邮箱</td>
                <td>imap.139.com</td>
                <td>993</td>
                <td>pop.139.com、pop.10086.cn</td>
                <td>995</td>
                <th><a href="http://help.mail.10086.cn/statichtml/0/Content/1454.html"> 139邮箱服务器地址</a></th>
              </tr>

              <tr>
                <td>263企业邮箱</td>
                <td>imap.263.net</td>
                <td>993</td>
                <td>pop.263.net</td>
                <td>995</td>
                <th><a href="https://www.263.net/263/helpcenter/client/20160603/970.html"> 263服务器地址</a></th>
              </tr>

              <tr>
                <td>263企业邮箱(海外）</td>
                <td>imapw.263.net</td>
                <td>993</td>
                <td>popw.263.net</td>
                <td>995</td>
                <th><a href="https://www.263.net/263/helpcenter/client/20160603/970.html"> 263服务器地址</a></th>
              </tr>

              <tr>
                <td>全球邮</td>
                <td>建议您使用在线查询</td>
                <td>993</td>
                <td>建议您使用在线查询</td>
                <td>995</td>
                <th><a href="http://www.xinnet.com/service/cjwt/mail/shezhi/938.html"> 全球邮服务器地址</a></th>
              </tr>

            </tbody>
          </table>

          <p>（2）如果您是使用的公司自建服务器，请您联系贵公司技术人员，询问贵公司的邮件服务器地址和端口号。
            有许多公司有自己的邮件服务器，公司员工的邮箱通常为xxx@公司名.com。如果贵公司有自己的邮件服务器，请填写贵公司的
            服务器地址和端口号。</p>

          <p>（3）如果有自建文件夹，推荐使用IMAP协议。</p>

          <p>（4）163邮箱如果使用IMAP协议绑定失败，尝试使用二-2-（1）解决，或者使用pop协议</p>

          <blockquote>
            <h2 id="5">第5步：设置招聘渠道</h2>
          </blockquote>

          <!-- <p><img src="./邮箱绑定教程_files/1577414159914.png" alt=""></p> -->

          <p>请根据您的情况选择需要抓取的招聘门户的简历邮件。</p>

          <blockquote>
            <h2 id="6">第6步：设置开始接收日期</h2>
          </blockquote>

          <!-- <p><img src="./邮箱绑定教程_files/1577414183925.png" alt=""></p> -->

          <h3 id="20170101">用于设置智能同步的开始日期，此日期必须填写180天之内的日期（因之前的简历格式无法准确识别）。</h3>

          <blockquote>
            <h2 id="">三、使用过程中会遇到哪些问题？</h2>
          </blockquote>

          <h3 id="1-2">问题1：绑定不成功，账号密码错误或邮箱服务未开启。</h3>

          <!-- <p><img src="./邮箱绑定教程_files/1577414213507.png" alt=""></p> -->

          <p>此情况请依次检查以下3项</p>

          <p>密码：许多邮箱服务商出于安全考虑，要求用户使用授权码作为密码，具体设置参照 绑定步骤第二步：填写密码。</p>

          <p>服务器类型：请确保自己已成功开启您所选择的服务器类型：IMAP/POP3/EXchange，具体设置参照 绑定步骤第3步：选择邮箱服务器类型</p>

          <p>账号：少数情况下，登录账号与邮箱域名不同，请确认自己的登录账号是否为邮箱域名，此情况较为少见。</p>

          <h3 id="2-2">问题2：绑定不成功，邮箱配置验证失败。</h3>

          <!-- <p><img src="./邮箱绑定教程_files/1577414237065.png" alt=""></p> -->

          <p>此情况较为复杂，可能为以下情况中的一种：</p>

          <p>（1）如果网易的163/126/yeah邮箱，在使用授权码绑定邮箱时，还是提示绑定失败，有可能是被认为账号存在风险，将客户端登陆禁用。需要手动解禁，各邮箱的链接如下：</p>

          <p>163邮箱：http://config.mail.yeah.net/settings/imap/login.jsp?uid=163邮箱（将“163邮箱”换成要绑定的163邮箱地址）</p>

          <p>126邮箱：http://config.mail.yeah.net/settings/imap/login.jsp?uid=126邮箱（将“126邮箱”换成要绑定的126邮箱地址）</p>

          <p>yeah邮箱：http://config.mail.yeah.net/settings/imap/login.jsp?uid=yeah邮箱（将“yeah邮箱”换成要绑定的yeah邮箱地址）</p>

          <p>示例1：邮箱是
            123456@163.com，在浏览器地址栏中输入http://config.mail.yeah.net/settings/imap/login.jsp?uid=123456@163.com，点回车，如下图：</p>

          <!-- <p><img src="./邮箱绑定教程_files/1577414406452.jpg" alt=""></p> -->

          <p>在页面中输入邮箱的登陆密码，是登陆密码，不是授权码。输入密码后，再点登录，如下图：</p>

          <!-- <p><img src="./邮箱绑定教程_files/1577414424684.jpg" alt=""></p> -->

          <p>勾选“已知悉以上信息”，如下图：</p>

          <!-- <p><img src="./邮箱绑定教程_files/1577414473872.jpg" alt=""></p> -->

          <p>点击下一步，显示手机验证，如下图：</p>

          <!-- <p><img src="./邮箱绑定教程_files/1577414493532.jpg" alt=""></p> -->

          <p>获取手机验证码之后，点击确定即可。完成安全验证。</p>

          <p>（2）服务器类型与服务器地址不对应。</p>

          <p>示例，QQ邮箱的IMAP服务器地址为imap.qq.com。详细对应参考绑定步骤的第4步：填写服务器地址和端口号的表。</p>

          <h3 id="3-1">问题3：绑定成功但收取邮件不全。</h3>

          <!-- <p><img src="./邮箱绑定教程_files/1577414520027.png" alt=""></p> -->

          <p>可以到邮箱设置收取邮件接收规则，将收取最近30天邮件改为收取全部邮件。</p>

          <h3 id="4-1">问题4：绑定成功但收取不到任何邮件</h3>

          <p>原因：邮箱服务器地址填写错误。</p>

          <p>说明：这种情况一般发生在公司有自建的服务器。一个邮箱域名可以配置多个服务器，但只有优先级最高的服务器可以接收到邮件。因此应当填写优先级最高的邮箱服务器。</p>

          <p>解决方法：询问贵公司技术人员邮箱服务器地址以及端口号，填写。</p>

          <h3 id="5-1">问题5：系统首页或渠道绑定页面出现邮箱绑定异常，一般是因为邮箱的登陆密码被修改。</h3>

          <p>提示如下图：</p>

          <!-- <p><img src="./邮箱绑定教程_files/1577414544895.png" alt=""></p> -->

          <!-- <p><img src="./邮箱绑定教程_files/1577414562241.png" alt=""></p> -->

          <h3 id="6-1">问题6：如果简历邮件被邮箱归为垃圾邮件、广告邮件或推广邮件等，请将此邮件标记为非垃圾邮件或信任此邮件，并将其转移到默认收件箱或自建文件夹。</h3>

          <blockquote>
            <h3 id="-1">如有疑问，请联系易招聘客服同学！</h3>
          </blockquote>
        </div>
        <!-- <p class="company"><span>2020&nbsp;©&nbsp;企家有道网络技术（北京）有限公司&nbsp;&nbsp;&nbsp;联系我们：400-666-1290</span></p> -->
      </div>
    </div>
    <div id="extensionXrxs" data-version="2.1.1" data-extensionid="cegcpiejpkjgniflhpaefbgpnhdlklml"></div>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    mounted: function() {
      this.$store.dispatch("first_nav_change", "111");
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/pages/getEmail.vue